module.exports = __webpack_public_path__ + "static/media/star-runner-screenshot-5.b7f89641.jpg";